export default function ExpertiseBand() {
  const highlights = [
    { icon: "ri-scales-3-line", title: "부장판사출신변호사", desc: "부장판사경력 15년" },
    { icon: "ri-file-shield-2-line", title: "검사출신변호사", desc: "검사경력 6년" },
    { icon: "ri-award-line", title: "형사법전문변호사", desc: "대한변호사협회 등록" },
    { icon: "ri-flashlight-line", title: "원스톱 대응", desc: "수사부터 재판·집행까지" },
  ];

  return (
    <div className="relative z-20 mx-auto -mt-36 -mb-8 max-w-7xl px-4 md:-mt-10 md:-mb-12 md:px-6">
      <div className="rounded-xl border border-background-200 bg-white/80 backdrop-blur-sm px-5 py-7 md:p-6">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-0 lg:divide-x lg:divide-background-200">
          {highlights.map((h) => (
            <div
              key={h.title}
              className="flex items-center gap-4 lg:px-6 lg:first:pl-0 lg:last:pr-0"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-accent-50 text-accent-600">
                <i className={`${h.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <p className="font-heading text-base font-semibold text-foreground-950">{h.title}</p>
                <p className="mt-0.5 text-xs leading-snug text-foreground-600 md:text-sm">{h.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}